import styled from "styled-components";
import { getCommonProps } from "../../types";
import { SVGProps } from "./types";


const Wrapper = styled.svg<Omit<SVGProps, "width" | "height"> & { width: string, height: string}>`
    ${props => {
        if (props.color) return { color: props.color}
    }}
    ${(props) => getCommonProps(props)}
    &:hover {
        ${props => props.onClick ? ({ cursor: "pointer "}) : {}}
    }
    ${(props => props.secondary ? ({ color: props.theme.colors.text.secondary}) : {})};
`;

const SVG = (props: SVGProps) => {
    return (
        <Wrapper

            onClick={props.onClick}
            className={props.className}
            type={props.name}
            xmlns="http://www.w3.org/2000/svg"
            viewBox={`0 0 ${props.width} ${props.height}`}
            fill={props.fill ?? "currentColor"}
            {...props}
            width={props.fullWidth ? "100%" :`${props.width}px`}
            height={props.fullHeight ? "100%" :`${props.height}px`}
            style={{...props.styles}}
        >
            {props.children}
        </Wrapper>
    );
};

export default SVG;
